export default ({ request }) => ({
    scmInfoGetScoreListApi(data) {
      return request({
        url: '/digitalCenter/scmInfoScore/getScoreList',
        method: 'post',
        data
      })
    }
  })
  